import React from 'react';
import { X, HelpCircle, Loader2 } from 'lucide-react';

const ConfirmModal = ({ open, onClose, onConfirm, message, loading = false, hideActions = false }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-bg-60 rounded-xl p-6 w-full max-w-md relative">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 bg-bg-50 text-fg-60 hover:text-fg-50 transition-colors"
          aria-label="Close"
        >
          <X size={22} />
        </button>
        {/* Icon */}
        <div className="flex justify-center mb-4">
          <HelpCircle className="h-12 w-12 text-ac-02" />
        </div>
        {/* Message */}
        <div className="text-center text-xl font-semibold text-fg-80">{message}</div>
        {/* Buttons */}
        {!hideActions && (
          <div className="flex justify-center gap-4 mt-6">
            <button
              onClick={onClose}
              className="px-5 py-2 rounded-lg bg-bg-50 hover:bg-bg-50 text-fg-60 font-medium shadow-sm transition-colors border border-bd-50 text-xs"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              disabled={loading}
              className={`px-5 py-2 rounded-lg bg-gradient-to-r from-ac-02 to-ac-01 hover:from-ac-01 hover:to-ac-02 text-white dark:text-black font-semibold shadow-md transition-all border border-ac-02 flex items-center justify-center min-w-[100px] text-xs ${
                loading ? 'opacity-75 cursor-not-allowed' : ''
              }`}
            >
              {loading ? (
                <>
                  <Loader2 className="animate-spin mr-2 h-4 w-4" />
                  Processing...
                </>
              ) : (
                'Confirm'
              )}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConfirmModal; 